import { fetchWrapper, handleResponse, hcUrl, buildOpts } from 'services/RequestService/helpers';

export const getMealAddons = async () => {
  const response = await fetchWrapper(hcUrl('/meal_addons'), buildOpts());

  return handleResponse(response);
};
